var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { background: "none", padding: "9px" } },
    [
      _c(
        "v-badge",
        {
          attrs: { color: "red" },
          scopedSlots: _vm._u(
            [
              _vm.count_not_read != 0
                ? {
                    key: "badge",
                    fn: function() {
                      return [
                        _c("span", [
                          _vm._v(" " + _vm._s(_vm.count_not_read) + " ")
                        ])
                      ]
                    },
                    proxy: true
                  }
                : null
            ],
            null,
            true
          )
        },
        [
          _vm._v(" "),
          _c("img", {
            staticStyle: {
              "max-height": "50px",
              "max-width": "50px",
              "border-radius": "10px",
              cursor: "pointer"
            },
            attrs: {
              src:
                "https://onemail-chat.korkla.in/backend/api/v1/getFile/4379aa7a-4c58-4c8c-8c93-2083e9801f04/app_logo.png"
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1716d0fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1716d0fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mail/minChat.vue
// module id = null
// module chunks = 